export enum DidomiActionType {
    RAT_APPCONFIG = 'RAT_APPCONFIG',
}

export type DidomiAction = { type: DidomiActionType.RAT_APPCONFIG; appConfig: any };
